<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Organigrama empresarial</span>
	  		    <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( organigrama  , 'ORGANIGRAMA')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headersDetalles"
							    :items="organigrama"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							   
							   	<template v-slot:item.sexo="{ item }">
			              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
			              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
			              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
			            </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      organigrama: [],
      puestos:[],
      planteles:[],
			turnos:[],
			
      url:'',

      vacantes_detalles:[],
      dialogDetalles: false,

      headersDetalles: [
        { text: 'Puesto'               , value: 'puesto'                   },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'F. Apertura'          , value: 'fecha_apertura'           },
        { text: 'F. Compromiso'        , value: 'fecha_compromiso'         },
        { text: 'Reclutador'           , value: 'nombre_reclutador'        },
        { text: 'Días espera'          , value: 'dias_sin_cubrir'          },
        { text: 'Vacantes'             , value: 'vacantes'                 },
      ],


      dialogAddDetalle: false,
      puestosAll: [],

      usuarios: [],

      vacantes_requeridos:[],
      dialogRequeridos: false,

    }),

    computed: {
    	...mapGetters('login',['getCCNNUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar datos' : 'Editar datos'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      this.url = 'https://escuelakpi.club/documentacionrh/'

      await this.initialize( )
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.organigrama = []
        return this.$http.get('organigrama.v2').then(response=>{

        	let vacantes = []

        	for( const i in response.data ){

        		const { vacantes_detalles } = response.data[i]

        		let misVacantes = vacantes_detalles.filter( el => el.reclutador == this.getCCNNUsuario.iderp )

        		if( misVacantes.length > 0  ){

        			vacantes = vacantes.concat( misVacantes )
        		
        		}

        	}


        	this.organigrama = vacantes

        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },
    },
  }
</script>


